import {useMutation, useQueryClient} from '@tanstack/react-query';

import {trustAccountActivityKeys} from '@/features/trust-accounts/hooks/useTrustAccountActivity';
// Direct path, not the feature barrel — the barrel re-exports hooks that import this module back.
import {invalidatePaymentInstructions} from '@/features/trust-accounts/utils/trust-account-invalidations.utils';
import {useApiClient} from '@/hooks';

import {paymentsApi} from '../api';

export function useResendPaymentInstructionMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentId: string) =>
      paymentsApi.resendPaymentInstruction(client, trustAccountId, paymentId, crypto.randomUUID()),
    onSuccess: () => {
      // Keeps `canDelete` consistent with the other payment-instruction mutations.
      invalidatePaymentInstructions(queryClient, trustAccountId);
      queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.tabCounts(trustAccountId)});
      queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.stats(trustAccountId)});
    }
  });
}
